@if (bookingItem$ | async; as bookingItem) {
  <div>
    <ub-card [rounded]="true">
      <h1 title>{{ bookingItem.doc.name }}</h1>
      <div actions>
        <ub-label label="State" [text]="workflow.title" i18n-label></ub-label>
      </div>
    </ub-card>
    @if (bookableOptions$ | async; as bookableOptions) {
      @for (option of bookableOptions; track option) {
        <eas-booking-item-integration-option [bookingItemOption]="option"
        ></eas-booking-item-integration-option>
      }
    }
  </div>
}
